import Player from './Player';
class YoutubePlayer extends Player {
    constructor(element) {
        super(element);
        this.media = null;
        // @ts-ignore
        this.player = null;
        this.element.addEventListener('videoPlayer.loadScript', () => {
            this.events.scriptLoaded = new CustomEvent('videoPlayer.youtubeScriptLoaded');
            this.media = this.element.querySelector('iframe');
            if (this.media) {
                document.addEventListener('videoPlayer.youtubeScriptLoaded', () => {
                    this.onload();
                });
                this.importScript('https://www.youtube.com/iframe_api', 'script-youtube-player');
            }
        });
    }
    onload() {
        // @ts-ignore
        this.player = new window.YT.Player(this.media, {
            events: {
                onReady: () => {
                    this.onPlayerReady();
                },
                onStateChange: () => {
                    this.onPlayerStateChange();
                },
            },
        });
    }
    importScript(url, id, onload = null) {
        var _a;
        if (!document.scripts.namedItem(id)) {
            // @ts-ignore
            window.onYouTubeIframeAPIReady = () => {
                var _a;
                (_a = document.scripts.namedItem(id)) === null || _a === void 0 ? void 0 : _a.setAttribute('data-loaded', '1');
                document.dispatchEvent(this.events.scriptLoaded);
            };
            super.importScript(url, id);
        }
        else if (document.scripts.namedItem(id) && ((_a = document.scripts.namedItem(id)) === null || _a === void 0 ? void 0 : _a.dataset.loaded)) {
            this.onload();
        }
    }
    play() {
        this.player.playVideo();
    }
    stop() {
        this.player.pauseVideo();
    }
    mute() {
        this.player.mute();
    }
    unmute() {
        this.player.unMute();
    }
}
export default YoutubePlayer;
